import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AccompanyingService {

    constructor( private http: HttpClient ) {}

    createAccompanyingRequest(operatorId: number, folioFollowing: string) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const body = {
            operatorId: operatorId,
            folio_following: folioFollowing,
        }

        return this.http.post<any>(`${environment.apiUrl}/accompanying_documents/new-request`, body, { headers });
    }

    validateFolio(folio: string) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        }

        return this.http.post<any>(`${environment.apiUrl}/accompanying_documents/validate/${folio}`, {}, { headers })
    }

    deleteAccompanyingRequest(accompanyingId: number) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.delete<any>(`${environment.apiUrl}/accompanying_documents/delete-request/${accompanyingId}`, { headers });
    }

    getPendingAccompanyingRequest(page: number, search: string) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const body = {
            page: page,
            search: search
        }

        return this.http.post<any>(`${environment.apiUrl}/accompanying_documents/pending-request`, body, { headers });
    }

    getSignAccompanyingRequest(page: number, search: string) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const body = {
            page: page,
            search: search
        }

        return this.http.post<any>(`${environment.apiUrl}/accompanying_documents/signed-request`, body, { headers });
    }

    getApprovedAccompanyingRequest(page: number, search: string) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const body = {
            page: page,
            search: search
        }

        return this.http.post<any>(`${environment.apiUrl}/accompanying_documents/approved-request`, body, { headers });
    }

    getAccompanyingDocumentsHistorical(operatorId: number) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.get<any>(`${environment.apiUrl}/accompanying_documents/documents/${operatorId}`, { headers });
    }

    signAccompanyingRequest(accompanyingId: number) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.patch<any>(`${environment.apiUrl}/accompanying_documents/sign-request/${accompanyingId}`, {}, { headers });
    }

    validateAccompanyingRequest(accompanyingId: number) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.patch<any>(`${environment.apiUrl}/accompanying_documents/validate-request/${accompanyingId}`, {}, { headers });
    }

    getFormAccompanyingRequest(accompanyingId: number, formId: number) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.get<any>(`${environment.apiUrl}/accompanying_documents/${accompanyingId}/form/${formId}`, { headers });
    }

    submitFormAccompanyingRequest(accompanyingId: number, formId: number, formData: any, folio: string = '', fecha: string = '') {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        let body = {
            submission: []
        }

        body.submission.push({
            name: 'folio',
            value: folio
        })

        body.submission.push({
            name: 'fecha',
            value: fecha
        })

        for (var i in Object.keys(formData)) {
            const key = Object.keys(formData)[i]
            body.submission.push({
                name: key,
                value: formData[key]
            })
        }

        return this.http.post<any>(`${environment.apiUrl}/accompanying_documents/${accompanyingId}/form/${formId}`, body, { headers });
    }

    getBuyers(customerId: number, search: string) {
        if (search === '' || (typeof customerId !== 'number' && customerId === 0)) {
            return of([]);
        }

        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        }

        return this.http.get<any>(`${environment.apiUrl}/accompanying_documents/search_buyers/${customerId}/${search}`, { headers }).pipe(
            map(response => {
                //console.log(response['data'])
                return response['data']
            })
        )
    }

    uploadAttachmentAccompanyingDocument(accompanyingId: number, file: File) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const formData = new FormData()
        formData.append('file', file, file.name)

        const headers = {
            'Authorization': jwtToken
        };

        return this.http.patch<any>(`${environment.apiUrl}/accompanying_documents/upload_attachment/${accompanyingId}`, formData, { headers });
    }
}